import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export interface ITrackAmplitudeComponentActionParams {
    componentName: string;
    /** Type of the first interaction. Defaults to "first_interaction". */
    action?: string;
    location: string;
    itemId: number;
    propertyId?: number | null;
}

export const trackAmplitudeComponentAction = (params: ITrackAmplitudeComponentActionParams) => {
    const {componentName, action = "first_interaction", location, itemId, propertyId} = params;

    trackAmplitudeEvent("component_action", {
        component_name: componentName,
        action,
        location,
        item_id: itemId,
        property_id: propertyId ?? null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export interface ITrackAmplitudeComponentActionParams {
    componentName: string;
    /** Type of the first interaction. Defaults to "first_interaction". */
    action?: string;
    location: string;
    itemId: number;
    propertyId?: number | null;
}

export const trackAmplitudeComponentAction = (params: ITrackAmplitudeComponentActionParams) => {
    const {componentName, action = "first_interaction", location, itemId, propertyId} = params;

    trackAmplitudeEvent("component_action", {
        component_name: componentName,
        action,
        location,
        item_id: itemId,
        property_id: propertyId ?? null
    });
};
